import React from "react";
import AddressViewLoader from "./View";
import { ModalComponent, IModalProps } from "/imports/client/components/modals";
import { IAddressViewProps } from "./View.d";

interface IAddressViewModalProps
  extends IAddressViewProps,
    Pick<IModalProps, "show"| "showModal"> {}

const AddressViewModal = ({
  show,
  showModal,
  ...props
}: IAddressViewModalProps) => {
  return (
    <ModalComponent
      show={show}
      showModal={showModal}
      body={<AddressViewLoader {...props} />}
    />
  );
};

export default AddressViewModal;
